import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CrmExportComparePipe } from './crm-export-compare.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [CrmExportComparePipe],
  exports: [CrmExportComparePipe]
})
export class CrmExportComparePipeModule {} 
